module.exports = __webpack_public_path__ + "media/images/department-df0efd5e2ad0cffc32e2e64e85432db6.svg";